import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col,Container } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';
import { Link } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import API from '../Utils/Api';
import { validatelocation } from '../Utils/validate';
import loader from '../assests/loader.gif';
import { gettoastwarning, gettoastsuccess } from '../Utils/Common';
import { removeUserSession } from '../Utils/Common';

const NeighbourHeaderAfterLogin = ({ toggleSidebar }) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showInfo, setShowInfo] = useState(false);
  const handleInfo = () => {
    setShowInfo(prev => !prev);
  };
  const [data, setData] = useState('');
  const [location, setLocation] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputsl, setInputsl] = useState({ pincode: '', state: '', city: '', town: '' });

  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [town, setTown] = useState([]);

  const [businesschk, setBusinesschk] = useState(1);

  const [businessid, setBusinessid] = useState(1);

  const [isproverify, setIsproverify] = useState(0);
  

  useEffect(() => {
    /* Start get profile */
    API.get('get_user_detail')
      .then(response => {

        if (response.data.status === false) {

        } else {
          setData(response.data.data);
          setLocation(response.data.data.location);
        }
      }).catch(error => {

      });
    /* End get profile */
    API.post('get_state')
      .then(response => {
        setState(response.data.data);
      });

    API.post('get_business_with_user_login')
      .then(response => {
        setLoading(false);
        if (response.data.status === false) {

        } else {
          setBusinesschk(response.data.data.status);
          setBusinessid(response.data.data.business_id);
          setIsproverify(response.data.data.is_profile_verify);
        }
      }).catch(error => {

      });
  }, []);


  /* Start Value set */
  const handleInputChange = (event) => {
    event.persist();
    setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));
  }
  /* End Value set */

  const getCity = (event) => {
    event.preventDefault();
    setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

    setTown([]);

    var st = 'city';
    var st_val = '';
    setInputsl(inputsl => ({ ...inputsl, [st]: st_val }));

    var ct = 'town';
    var ct_val = '';
    setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));

    let formData = new FormData();
    formData.append('state_id', event.target.value);
    API.post('get_city', formData)
      .then(response => {
        if (response.data.status === true) {
          setCity(response.data.data);
        } else {

        }
      }).catch(error => {

      });
  }

  const getTown = (event) => {
    event.preventDefault();
    setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));

    setTown([]);
    var ct = 'town';
    var ct_val = '';
    setInputsl(inputsl => ({ ...inputsl, [ct]: ct_val }));



    let formData = new FormData();
    formData.append('city_id', event.target.value);
    API.post('get_town', formData)
      .then(response => {
        if (response.data.status === true) {
          setTown(response.data.data);

          var ct1 = 'town';
          var ct_val1 = response.data.extra_data.town_id;
          setInputsl(inputsl => ({ ...inputsl, [ct1]: ct_val1 }));

          var pin1 = 'pincode';
          var pin_val1 = response.data.extra_data.pincode;
          setInputsl(inputsl => ({ ...inputsl, [pin1]: pin_val1 }));

        } else {

        }
      }).catch(error => {

      });
  }

  const getpicode_town = () => {
        if (inputsl.pincode !== '') {
            let formData = new FormData();
            formData.append('pin_code', inputsl.pincode);
            API.post('get_pincode_town', formData)
                .then(response => {

                    if (response.data.status === true) {
                        if (response.data.data.city_id !== '' && response.data.data.state_id !== '') {
                            setCity(response.data.data.city);
                            setTown(response.data.data.town);
                            var state_label = 'state';
                            var state = response.data.data.state_id;
                            setInputsl(inputsl => ({ ...inputsl, [state_label]: state }));

                            var city_label = 'city';
                            var city = response.data.data.city_id;
                            setInputsl(inputsl => ({ ...inputsl, [city_label]: city }));

                            var town_label = 'town';
                            var town = response.data.data.town_id;
                            setInputsl(inputsl => ({ ...inputsl, [town_label]: town }));

                            var town_text=response.data.data.town_name;
                            var town_name_lbl="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl]: town_text }));

                        }else{
                            setCity([]);
                            setTown([]);
                            var state_label3 = 'state';
                            var state3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [state_label3]: state3 }));

                            var city_label3 = 'city';
                            var city3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [city_label3]: city3 }));

                            var town_label3 = 'town';
                            var town3 = '';
                            setInputsl(inputsl => ({ ...inputsl, [town_label3]: town3 }));

                            var town_text3='';
                            var town_name_lbl3="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl3]: town_text3 }));
                        }
                    } else {
                        setCity([]);
                        setTown([]);
                        var state_label1 = 'state';
                        var state1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [state_label1]: state1 }));

                        var city_label1 = 'city';
                        var city1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [city_label1]: city1 }));

                        var town_label1 = 'town';
                        var town1 = '';
                        setInputsl(inputsl => ({ ...inputsl, [town_label1]: town1 }));

                        var town_text1='';
                            var town_name_lbl1="town_name";
                            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl1]: town_text1 }));
                    }
                }).catch(error => {

                });
        }else{
            setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputsl(inputsl => ({ ...inputsl, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputsl(inputsl => ({ ...inputsl, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputsl(inputsl => ({ ...inputsl, [town_label2]: town2 }));

            var town_text2='';
            var town_name_lbl2="town_name";
            setInputsl(inputsl => ({ ...inputsl, [town_name_lbl2]: town_text2 }));
        }
    }

    const getCat = (event) => {
        event.preventDefault();
        setInputsl(inputsl => ({ ...inputsl, [event.target.name]: event.target.value }));
        get_town_picode(event.target.value);
    }
    const get_town_picode = (id) => {
        let formData = new FormData();
        formData.append('town_id', id);
        API.post('get_town_pincode', formData)
            .then(response => {

                if (response.data.status === true) {
                    if (response.data.data.city_id !== '') {
                        var pincode_label = 'pincode';
                        var pincode_val = response.data.data.pincode;
                        setInputsl(inputsl => ({ ...inputsl, [pincode_label]: pincode_val }));
                    }
                } else {

                }
            }).catch(error => {

            });
    }
  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validatelocation(inputsl);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors({});
    setErrors(validationErrors);

    if (noErrors) {
      setLoading(true);

      let formData = new FormData();
      Object.keys(inputsl).forEach((key) => {
        formData.append(key, inputsl[key]);
      });
      API.post('add_location', formData)
        .then(response => {
          if (response.data.status === false) {
            //setError(response.data.message);
            setLoading(false);
            gettoastwarning(response.data.message, '');
          } else {
            setLoading(false);
            gettoastsuccess(response.data.message, '');
            window.location.reload();
          }
        }).catch(error => {
          setLoading(false);
          gettoastwarning("Something went wrong. Please try again later.", '');
          //setError("Something went wrong. Please try again later.");
        });
    }
    //navigate('/neighbour/login');
  };
  /* Start logout */
  const logout = () => {
    removeUserSession();
    window.location.href = "/";
    //<Navigate to="/" />
  }
  /* End logout */
  const busred = () => {
    localStorage.setItem("business_id", businessid);
    localStorage.setItem("is_profile_verify_buss", isproverify);
    if(isproverify===1){
      window.location.href = '/business/my-deal';
    }else{
      window.location.href = '/business/edit-business';
    }
  }

  const sel_location = (val) => {
    localStorage.setItem("location_id", val.id);
    const loc = `${val.town_name} - ${val.pincode}`;
    localStorage.setItem("location", loc);
    window.location.reload();
  };

  return (
    <>
      <div className='info-box d-none'>
        <Container>
        <Row className='info-top'>
          <Col><p>Weekend plans need a little extra? extra 15% off should help!</p></Col>
          <Col xs="auto"><Link to="" onClick={handleInfo}> <span> {showInfo ? 'Hide Detail' : 'View Detail'} </span> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className={`img-fluid ${showInfo ? 'tr180' : ''}`} alt="drop-wh" /></Link></Col>
        </Row>
        {showInfo && (
          <div className='info-bot'>
            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/info.webp'} className="img-fluid" alt="info" />
            <p>jsdjk sjksjkl jsdkljf sdkljfklsdnkljnsdklfj sdkljklsdjfksjfkljsdlkj</p>
          </div>
        )}
      </Container>
      </div>
      <div className='nei-header al-user-header'>
        <div>
          <Dropdown className='mob-hide'>
            <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
              <h6>{localStorage.getItem('location') || 'My Locations'}</h6>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-loc-drop header-drop'>
              <h6>My Locations</h6>
              {location && location.map((val, index) => {
                return (
                  <Link to="" onClick={() => sel_location(val)}>
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/city.webp'} className="img-fluid" alt="city" />
                      <h6>{val.town_name} - {val.pincode}</h6>
                    </div>
                  </Link>
                );
              })}
              <h6>Add New Locations</h6>
              <Link to="" className='ant-box' onClick={handleShow}>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/open.webp'} className="img-fluid" alt="open" />
                  <h6>Select Location</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
          <Dropdown>
            <Dropdown.Toggle variant="success" id="aflogindrop" className='header-user-box'>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/user.webp'} className="img-fluid" alt="user" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-user-drop header-drop'>
              <div className='user-prof'>
        
                {data?.first_name?.trim() ? (
                  <div>
                    {data.first_name.charAt(0).toUpperCase()}
                  </div>
                ) : (
                  <div className="img-place">
                    <Image
                      src={`${process.env.REACT_APP_BASE_URL}assets/images/user_image.png`}
                      className="img-fluid"
                      alt="user"
                    />
                  </div>
                )}

                <h5>{data.first_name} {data.last_name}</h5>
                <Link to="/neighbour/view-profile">View Profile</Link>
              </div>
              {/* <Link to="/neighbour/view-profile">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/profile.webp'} className="img-fluid" alt="profile" />
                  <h6>My Profile</h6>
                </div>
              </Link> */}
              {businesschk === 1 ? (
                <Link to="#" onClick={(e) => { e.preventDefault(); busred(); }}>
                  <div>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/my-business.webp'} className="img-fluid" alt="ian" />
                    <h6>My businesses</h6>
                  </div>
                </Link>
              ) : (
                <Link to="/neighbour/switch-business-profile">
                  <div>
                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                    <h6>Switch to Business Profile</h6>
                  </div>
                </Link>
              )}
              <Link to="/neighbour/invite-a-neighbor">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/ian.webp'} className="img-fluid" alt="ian" />
                  <h6>Invite a Neighbor</h6>
                </div>
              </Link>
              {/* <Link to="/neighbour/contact-us">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/cnt.webp'} className="img-fluid" alt="cnt" />
                  <h6>Contact Us</h6>
                </div>
              </Link> */}
              <Link to="/neighbour/settings">
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/setting.webp'} className="img-fluid" alt="setting" />
                  <h6>Settings</h6>
                </div>
              </Link>
              <Link to="#" onClick={logout}>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/logout.webp'} className="img-fluid" alt="user" />
                  <h6>Logout</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="d-block d-sm-none">
          <Dropdown>
            <Dropdown.Toggle variant="success" id="ciytdrop" className='header-loc-box'>
              <h6>{localStorage.getItem('location') || 'My Locations'}</h6>
              <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/drop-wh.webp'} className="img-fluid" alt="drop" />
            </Dropdown.Toggle>
            <Dropdown.Menu className='header-loc-drop header-drop'>
              <h6>My Locations</h6>
              {location && location.map((val, index) => {
                return (
                  <Link to="" onClick={() => sel_location(val)}>
                    <div>
                      <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/city.webp'} className="img-fluid" alt="city" />
                      <h6>{val.town_name} - {val.pincode}</h6>
                    </div>
                  </Link>
                );
              })}
              <h6>Add New Locations</h6>
              <Link to="" className='ant-box' onClick={handleShow}>
                <div>
                  <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/open.webp'} className="img-fluid" alt="open" />
                  <h6>Select Location</h6>
                </div>
              </Link>
            </Dropdown.Menu>
          </Dropdown>        
        </div>
        <div className='wh-burger-box'>
          <Link onClick={toggleSidebar}>
            <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/wh-burger.webp'} className="img-fluid wh-burger" alt="wh-burger" />
          </Link>
          
        </div>
      </div>
      
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className='add-city-modal'
      >
        <Modal.Header closeButton>
          <h3>Add a New Location</h3>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label className='d-none'>Pin code</Form.Label>
              <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChange} onBlur={getpicode_town} value={inputsl.pincode} maxLength={6} />
            </Form.Group>
            {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
            <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputsl.state}>
              <option value="">State</option>
              {state && state.map((val, index) => {
                return (
                  <option value={val.id}>{val.name}</option>
                )
              })}
            </Form.Select>
            {errors.state && (<p className="text-danger">{errors.state}</p>)}
            <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputsl.city}>
              <option value="">City</option>
              {city && city.map((val, index) => {
                return (
                  <option value={val.id}>{val.name}</option>
                )
              })}
            </Form.Select>
            {errors.city && (<p className="text-danger">{errors.city}</p>)}
            <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputsl.town}>
              <option value="">Locality</option>
              {town && town.map((val, index) => {
                return (
                  <option value={val.id}>{val.name}</option>
                )
              })}
            </Form.Select>
            {errors.town && (<p className="text-danger">{errors.town}</p>)}
            <Button type="submit" className='blue-btn'>Add Location</Button>
          </Form>
        </Modal.Body>
      </Modal>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  )
}

export default NeighbourHeaderAfterLogin;                    